import { render, staticRenderFns } from "./the-personal-training-consultation.vue?vue&type=template&id=f8735ca4&"
import script from "./the-personal-training-consultation.vue?vue&type=script&lang=js&"
export * from "./the-personal-training-consultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports